import styled from "styled-components";

export const StyledCourses = styled.div`
  height: 100%;

  & .courses-header-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & .empty-content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .search-container {
    width: 250px;
  }

  & .filters-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-wrap: wrap;
  }

  & .courses-content {
    margin-top: 30px;
  }

  & .loader {
    padding-top: 25%;
  }

  & .grid-cols-2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;
